(function () {
  "use strict";

  var MIN_GAP = 4;
  var MAX_GAP = 12;
  var LIST_SELECTOR = ".product-swatches-options__list";
  var OVERFLOW_SELECTOR = ".product-swatches-options__overflow";

  function measure(element) {
    return Math.ceil(element.getBoundingClientRect().width);
  }

  function fitList(list) {
    var swatches = Array.prototype.filter.call(list.children, function (child) {
      return !child.classList.contains("product-swatches-options__overflow");
    });

    if (!swatches.length) return;

    var track = list.closest(".product-swatches-options") || list.parentElement;
    if (!track) return;

    var available = Math.floor(track.getBoundingClientRect().width);
    if (available <= 0) return;
    if (list.dataset.fittedWidth === String(available)) return;
    list.dataset.fittedWidth = String(available);

    var overflowItem = list.querySelector(OVERFLOW_SELECTOR);
    var overflowLink = overflowItem && overflowItem.firstElementChild;
    var label = list.dataset.swatchOverflowLabel || "+[[n]]";
    var rendered = swatches.length;
    var total = parseInt(list.dataset.swatchTotal, 10) || rendered;

    swatches.forEach(function (swatch) {
      swatch.hidden = false;
    });
    list.style.columnGap = MIN_GAP + "px";

    var swatchSize = measure(swatches[0]);
    if (!swatchSize) return;

    var step = swatchSize + MIN_GAP;
    var everythingFits =
      rendered === total && total * step - MIN_GAP <= available;

    var visible = rendered;
    var overflowWidth = 0;

    if (!everythingFits && overflowLink) {
      overflowItem.hidden = false;
      overflowLink.textContent = label.replace("[[n]]", total);
      overflowWidth = measure(overflowItem);

      visible = Math.max(
        1,
        Math.min(rendered, Math.floor((available - overflowWidth) / step)),
      );
    }

    swatches.forEach(function (swatch, index) {
      swatch.hidden = index >= visible;
    });

    var overflows = visible < total;

    if (overflowItem) {
      overflowItem.hidden = !overflows;

      if (overflows && overflowLink) {
        overflowLink.textContent = label.replace("[[n]]", total - visible);
        overflowWidth = measure(overflowItem);
      } else {
        overflowWidth = 0;
      }
    }

    var gapCount = (overflows ? visible + 1 : visible) - 1;
    var slack = available - (visible * swatchSize + overflowWidth);
    var distributed =
      overflows && gapCount > 0 ? slack / gapCount : MIN_GAP;
    var gap = distributed > MAX_GAP ? MIN_GAP : distributed;

    list.style.width = "100%";
    list.style.columnGap = gap.toFixed(2) + "px";
  }

  var resizeObserver =
    typeof ResizeObserver === "undefined"
      ? null
      : new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var list = entry.target.querySelector(LIST_SELECTOR);
            if (list) fitList(list);
          });
        });

  function bind() {
    document.querySelectorAll(LIST_SELECTOR).forEach(function (list) {
      if (list.dataset.swatchFitBound === "true") return;
      list.dataset.swatchFitBound = "true";

      var track = list.closest(".product-swatches-options");

      if (resizeObserver && track) {
        resizeObserver.observe(track);
      } else {
        fitList(list);
      }
    });
  }

  function refit() {
    document.querySelectorAll(LIST_SELECTOR).forEach(function (list) {
      delete list.dataset.fittedWidth;
      fitList(list);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  new MutationObserver(bind).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  if (!resizeObserver) {
    window.addEventListener("resize", refit);
  }
})();
